module.exports = __webpack_public_path__ + "static/media/ic-share-circle.e0031034.svg";